// extracted by mini-css-extract-plugin
export var checkList_item = "CheckListItem-module--checkList_item--5fab9";
export var checkMark = "CheckListItem-module--checkMark--3f470";